module.exports = __webpack_public_path__ + "img/material-card1-m.1a173449.png";